var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawerPromotionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3714 9.33495V18.5748H2.65138V9.33495H1.27994V19.2874C1.27994 19.681 1.58689 20 1.96564 20H18.0571C18.4358 20 18.7428 19.681 18.7428 19.2874V9.33495H17.3714Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3143 3.991H0.685703C0.306953 3.991 0 4.30999 0 4.70358V9.35915C0 9.75274 0.306953 10.0717 0.685703 10.0717H19.3143C19.693 10.0717 20 9.75295 20 9.35915V4.70358C20 4.30999 19.693 3.991 19.3143 3.991ZM18.6286 8.64682H1.37145V5.41644H18.6286V8.64682H18.6286Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6747 4.52254C10.6281 4.33776 9.49689 0 6.19423 0C4.75744 0 3.58853 1.21472 3.58853 2.70782C3.58853 4.20092 4.74716 5.41564 6.17138 5.41564H10.0114C10.2237 5.41564 10.4244 5.31326 10.5542 5.13843C10.684 4.96359 10.7284 4.73607 10.6747 4.52254ZM6.17142 3.99049C5.49213 3.99049 4.95998 3.42705 4.95998 2.70782C4.95998 2.01258 5.52525 1.42515 6.19427 1.42515C7.69896 1.42515 8.59998 2.96555 9.03314 3.99045H6.17142V3.99049Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8291 0C10.5265 0 9.39525 4.33776 9.34861 4.52255C9.29466 4.73607 9.33923 4.96363 9.46907 5.13847C9.59892 5.3133 9.79935 5.41568 10.0119 5.41568H13.8519C15.2761 5.41568 16.4348 4.20096 16.4348 2.70786C16.4348 1.21472 15.2659 0 13.8291 0ZM13.852 3.99049H10.9875C11.4175 2.96555 12.3158 1.42519 13.8293 1.42519C14.4984 1.42519 15.0636 2.01262 15.0636 2.70786C15.0636 3.42705 14.5315 3.99049 13.852 3.99049Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.697 4.70223H9.32553V19.2865H10.697V4.70223Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerPromotionsIcon);
export default __webpack_public_path__ + "static/media/drawer_promotions_icon.44f4ffa364187e69fde91dee48399d5f.svg";
export { ForwardRef as ReactComponent };